/* readyEvent
------------------------------------------------------------------------*/

$(function(){
  //375px未満はJSでviewport固定
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 375
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();

  // changeImg ---------------------------//
  var $elem = $('.change_img');
  var sp = '-sp.';
  var pc = '-pc.';
  var replaceWidth = 768;

  function imageSwitch() {
    var windowWidth = parseInt($(window).width());
    $elem.each(function() {
      var $this = $(this);
      if(windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      imageSwitch();
    }, 200);
  });
  // smoothScroll ---------------------------//
  var speed = 1000,
    easing = 'swing',
    pcPosition = -100,
    tabPosition = -90,
    spPosition = -90;

  $('a').not('.noscroll').click(function(){
    var href = $(this).attr('href'),
      case1 = href.charAt(0) == '#',
      case2 = location.href.split('#')[0] == href.split('#')[0];

    if(case1 || case2) {
      if(case2)
        href = '#'+href.split('#')[1];

      $target = $(href);

      if($target.length){
        $html.add($body).not(':animated').animate({scrollTop : String($target.offset().top + (lacook.pc ? pcPosition : lacook.tab ? tabPosition : spPosition))},speed,easing);

        return false;
      }
    }
  });

  // tel-link ---------------------------//
  var ua = navigator.userAgent;
  if(ua.indexOf('iPhone') > 0 && ua.indexOf('iPod') == -1 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 && ua.indexOf('SC-01C') == -1 && ua.indexOf('A1_07') == -1 ){
    $('.tel-link').each(function(){
      var str = $(this).text();
      $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
    });
  }

  // outerPageAnchorLink ---------------------------//
  if(window.location.href.split('#')[1] == undefined || window.location.href.split('#')[1].indexOf('=') == -1) {
    var $target = $('#'+window.location.href.split('#')[1]),
      adjust = (lacook.pc) ? pcPosition : (lacook.tab) ? tabPosition : spPosition;

    if($target.length) {
      $w.load(function(){
        var targetPosition = $target.offset().top;
        $html.add($body).animate({scrollTop: String(targetPosition + adjust)}, 10);
      });
    }
  }

  // inview ---------------------------//
  $('.js-inview').on('inview', function(event, isInView) {
    $(this).addClass('js-inview-in');
  });

  //ヘッダーメニュー
  $(".button-menu").click(function(){
    $(this).toggleClass('open');
    $(".con-modalmenu").toggleClass('open');
  });
  $(".con-modalmenu:before, .button-close, .con-modalmenu nav li a").click(function(){
    $(this).removeClass('open');
    $(".button-menu").removeClass('open');
    $(".con-modalmenu").removeClass('open');
  });

  //PCヘッダー固定メニュー
  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      $('header').removeClass('hamburger-menu-on');
    } else {
      $('header').addClass('hamburger-menu-on');
    }
  });
});